import filterAvailableInventories from "./filterAvailableInventories";

function searchQueryFilter(query, inventories) {
  const trimmedQuery = query.trim().toLowerCase();
  if (!trimmedQuery) return inventories;

  const filterFunction = (inventory) => {
    return (
      inventory?.locations?.name?.trim().toLowerCase().includes(trimmedQuery) ||
      inventory?.CodeNo?.trim().toLowerCase().includes(trimmedQuery) ||
      inventory?.typeOfMedia?.name?.trim().toLowerCase().includes(trimmedQuery)
    );
  };

  return inventories.filter(filterFunction);
}

// const filterByType = (types, item) => types.some(type => new RegExp(type, 'i').test(item.typeOfMedia?.name));
// const filterByArea = (areas, item) => areas.some(area => new RegExp(area, 'i').test(item.locations?.Area));
const filterByType = (types, item) =>
  types.some(
    (type) => item.typeOfMedia?.name?.toLowerCase() === type.toLowerCase()
  );
const filterByArea = (areas, item) =>
  areas.some(
    (area) => item.locations?.Area?.toLowerCase() === area.toLowerCase()
  );
const filterByZone = (zones, item) =>
  zones.some(
    (zone) => item.locations?.zone?.toLowerCase() === zone.toLowerCase()
  );

export default function multiFilter(
  types,
  areas,
  zones,
  startDate,
  endDate,
  inventories,
  searchQuery,
  duration
) {
  if (inventories.length === 0) return inventories;

  let filteredInventories = [...inventories];

  if (endDate) {
    filteredInventories = filterAvailableInventories(
      startDate,
      endDate,
      filteredInventories,
      duration
    );
  }

  if (searchQuery) {
    filteredInventories = searchQueryFilter(searchQuery, filteredInventories);
  }

  if (types.length > 0) {
    filteredInventories = filteredInventories.filter((item) =>
      filterByType(types, item)
    );
  }

  if (areas.length > 0) {
    console.log("🔥🔥", areas);
    filteredInventories = filteredInventories.filter((item) =>
      filterByArea(areas, item)
    );
    console.log(filteredInventories.map((ele) => ele.locations.Area));
  }

  if (zones.length > 0) {
    filteredInventories = filteredInventories.filter((item) =>
      filterByZone(zones, item)
    );
  }

  return filteredInventories;
}
